import { KybDocument } from '__generated__/GQL';

import getMandateDocument from './getMandateDocument';

const getMandateErrors = (
  kybDocuments: Pick<KybDocument, 'type' | 'status' | 'errorLocalized'>[],
) => {
  const mandate = getMandateDocument({ kybDocuments });

  return mandate?.errorLocalized ? [mandate?.errorLocalized] : [];
};

export default getMandateErrors;
